<template>
  <div class="footer">
    <div class="l-footer">
      <div class="l-footer-content">
        <div class="l-footer-img" @click="navigoTo({ path: `/home` })">
          <img class="l-logo" src="../../../static/logo-2.png" alt="logo" />
        </div>
        <div class="l-footer-list">
          <div class="l-footer-list-view" v-for="(s, i) in footer" :key="i">
            <div
              :class="[
                `l-footer-list-title`,
                s.title === `|` ? `l-footer-list-title-txt` : ``
              ]"
              @click="navigoTo(s)"
            >
              {{ s.title }}
            </div>
            <div
              class="l-footer-list-item"
              v-for="(item, key) in s.list"
              :key="key"
              @click="navigoTo(item)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <div>
          <div class="l-footer-ewm">
            <div class="l-f-e-pe">
              <div class="l-f-e l-f-e-phone">
                <div class="l-f-e-label">客服邮箱</div>
                <div class="l-f-e-value">{{ $config.phone }}</div>
              </div>
              <div class="l-f-e">
                <div class="l-f-e-label">合作邮箱</div>
                <div class="l-f-e-value">{{ $config.email }}</div>
              </div>
              <div class="l-f-e" style="margin-top: 20px">
                <div class="l-f-e-label">全球热线</div>
                <div class="l-f-e-value">{{ $config.telephone }}</div>
              </div>
            </div>
            <div class="l-f-e-pe">
              <div>
                <img
                  class="l-f-e-img"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAACBCAIAAABowk4HAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQaSURBVHhe7ZjLah1BEEPt/P8/O5ugzQGh7plcJaCzsemp1yBUzO3vn5+fr1Hl15+/o8c06DMN+kyDPtOgzzToMw36TIM+7jfa9/f3n/+uUGXW4aPkp+LrweYFmWWCE8wY80GfadAn2kWJ9wWz6OKHTZMWIhkjmTAZjCRZ80GfadDnbBfRs4IxR54VJt3M83p3kfQiR/PMB32mQZ9P7CLjRxY08xiSwQwP34uYLDIf9JkGfT66iwi7M9jUMelJ5QR2N/MIk0Xmgz7ToM8/d19EjgqaYDZlHZLUMSRZ80GfadAn2kV3GBf/1yd3qA6ZD/pMgz5uF/09Hvqa3G2MyruT+aDPNOhzuYv42SDMI8LVYbKSPaN0U5kTvjXGXcH5oM806HO2i4yLH9YhJsaMQcyozEp6JSSVxXzQZxr0ObsvugumnZMTw1EvcdSCsKnh6L3mgz7ToM/lLjKPRGLeu+5HmG1gHhmOBktazAd9pkGf93cRH4m7XiLxNWOSUZNeb52Q+aDPNOgT7SI6S5h0cmRechRjMG/BecRRlgkm80GfadDnbBeJxH2EweZEmMoPu5Oku5k5OSHzQZ9p0OdyFz3kLRcLBSewhYHdk8GOhp8P+kyDPm4XiSOnC2P5xOBJU1NHJL0MRwVFUlnMB32mQZ/Lu2tx532eCBYkrCMetjCVxV0MxxDzQZ9p0Cf6LhJ0ljlJYHemmxgzRoLpdVSQdYipMx/0mQZ9zr6LyJ1VjyzPGJNlgolpKpKCZjCekPmgzzToc3l3feTHBFNQJJVZRzzMOqqcjCrmgz7ToM/T+yJB9yUnwgQLkyWS9KSyuAtmL5M1H/SZBn2i+6LEYvQsYS9j1aQgSVrcnYhksKSOmA/6TIM+T3cRMTFJL/GwRdJdMeYRYQumHzEf9JkGfaJddETi4gRTRzwsyPSkKVGdu+00H/SZBn3OdhG9ZtyXBOvEYCqLJIaYwYSZmcEkCZ4P+kyDPtHdtbHh6yfEZAmm33XniTCPiKlM5oM+06DP5X0RSewsWOcoXTDYTCjuKhtM02Sw+aDPNOgTfRcRZjH4rcrEGJyPHr5FQjKGYT7oMw36vH93TZJtwBgzWBJsYrgokhNiYkx3Mh/0mQZ9Lr+LEu4cSoObMRhjXifBTGgGOxqVzAd9pkGfs7vrhKMsmvetrKPKDBZJlmJ4kjAf9JkGfc52UeJZ48fEvEnTpDJhHWEKHmHewjAf9JkGfT6xi5I6JpgkY5CjwY7mEXeDzQd9pkGfj34XCdYxLZLKR1kmWJhewlQ2J2Q+6DMN+nz0vkiPiAnWoyTdxAgGm/SjwRicMB/0mQZ9ol10h3GxSOyceD8ZNakskoIiSWeMmA/6TIM+bheNzzAf9JkGfaZBn2nQZxr0mQZ9pkGfadDm6+s3ZjS5o6c1g3gAAAAASUVORK5CYII="
                  alt="二维码"
                />
              </div>
              <div class="l-f-e-hint">扫码关注公众号</div>
            </div>
          </div>
        </div>
      </div>
      <div class="l-footer-bottom">
        <!-- ©2015-2019 斗米™ 北京世诚优聘科技发展有限公司 京ICP备15058772号 京公网安备11010802022669号 联系电话：010-57317000X -->
        <!-- <span class="l-foot-bottom-item">播聘网络技术(深圳)有限公司</span> -->
        <span class="l-foot-bottom-item">深圳播聘人才集团有限公司</span>
        <span class="l-foot-bottom-item">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            style="color: #007aff"
            >粤ICP备2022137216号-1</a
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serverPhone: `0755-2345 5678`,
      serverEmail: `bp@abopin.com`,
      footer: [
        {
          title: `关于播聘`,
          path: `/company-intr`,
          list: [
            {
              title: "公司简介",
              path: `/company-intr`
            },
            {
              title: "公司成长 ",
              path: `/company-grow`
            },
            {
              title: "公司荣誉",
              path: `/company-honor`
            },
            {
              title: "联系播聘",
              path: `/show-privacy-policy`
            }
          ]
        },
        {
          title: `|`,
          list: []
        },
        {
          title: `播聘资讯`,
          path: `/show-news`,
          list: [
            {
              title: "播聘新闻",
              path: `/show-news`
            },
            {
              title: "职场资讯",
              path: `/show-news`
            },
            {
              title: "职场故事",
              path: `/show-news`
            }
          ]
        },
        {
          title: `|`,
          list: []
        },
        {
          title: `帮助中心 `,
          path: "/show-help",
          list: [
            {
              title: "常见问题",
              path: "/company-issue"
            },
            {
              title: "发布规则",
              path: "/show-help"
            },
            {
              title: "隐私规则",
              path: "/privacy-rules"
            }
          ]
        },
        {
          title: `|`,
          list: []
        },
        {
          title: `播聘商学院 `,
          path: "/",
          list: [
            {
              title: "招聘技巧",
              path: "/recruitment-skills"
            },
            {
              title: "求职技巧",
              path: "/job-hunting-skills"
            }
          ]
        }
      ]
    };
  },
  methods: {
    navigoTo(s) {
      if (s.path) {
        this.$nav({ path: s.path }, this);
      }
    }
  }
};
</script>

<style scoped="scoped">
@import url("./footer.css");
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue